import { ReactElement } from 'react';

import BaseLayout from 'components/BaseLayout';

function Article(): ReactElement<HTMLElement> {
  return (
    <BaseLayout>
      <nav className="">
        <button className="mr-1.5 w-24 rounded-t-xl h-7 bg-indigo-200 last:mr-0"></button>
        <button className="mr-1.5 w-24 rounded-t-xl h-7 bg-indigo-200 last:mr-0"></button>
        <button className="mr-1.5 w-24 rounded-t-xl h-7 bg-indigo-200 last:mr-0"></button>
      </nav>

      <div className="flex flex-col lg:flex-row">
        <section className="lg:mr-10 lg:flex-grow">
          <header className="mb-10 h-64 rounded-r-xl rounded-bl-xl bg-red-200"></header>
          {Array(8)
            .fill(0)
            .map((x, idx) => (
              <article
                className="mb-5 flex flex-row rounded-xl bg-gray-200 last:mb-0"
                key={idx}
              >
                <div className="h-44 w-1/3 rounded-l-xl bg-indigo-200"></div>
              </article>
            ))}
        </section>
        <aside className="lg:w-1/3">
          <section className="mb-10 h-32 rounded-xl bg-gray-200"></section>

          <section className="mb-10">
            <article className="mb-3 h-5 bg-gray-200 rounded-full last:mb-0"></article>
            <article className="mb-3 h-5 bg-gray-200 rounded-full last:mb-0"></article>
            <article className="mb-3 h-5 bg-gray-200 rounded-full last:mb-0"></article>
          </section>

          <section className="mb-10 grid grid-cols-4 gap-3 place-items-center">
            <div className="h-16 w-16 rounded-full bg-gray-200"></div>
            <div className="h-16 w-16 rounded-full bg-gray-200"></div>
            <div className="h-16 w-16 rounded-full bg-gray-200"></div>
            <div className="h-16 w-16 rounded-full bg-gray-200"></div>
            <div className="h-16 w-16 rounded-full bg-gray-200"></div>
            <div className="h-16 w-16 rounded-full bg-gray-200"></div>
            <div className="h-16 w-16 rounded-full bg-gray-200"></div>
          </section>
        </aside>
      </div>
    </BaseLayout>
  );
}

export default Article;
